"use client";

/** Trailing-slash agnostic comparison for pathnames. */
export const normalizePath = (path: string): string =>
  path.length > 1 ? path.replace(/\/+$/, "") : path;

/** Path of the rendered `hreflang` alternate, or null when the locale has no twin. */
export const readAlternatePath = (locale: string): string | null => {
  const href = document.querySelector<HTMLLinkElement>(
    `link[rel="alternate"][hreflang="${locale}"]`,
  )?.href;

  return href ? new URL(href, window.location.origin).pathname : null;
};

/** The path next-intl would navigate to: the same route with the `/es` prefix added or removed. */
export const mirroredPath = (path: string, locale: string): string => {
  const englishPath = path.replace(/^\/es(?=\/|$)/, "") || "/";

  if (locale !== "es") {
    return englishPath;
  }

  return englishPath === "/" ? "/es" : `/es${englishPath}`;
};
